import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LoginComponent } from './login.component';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    CommonModule, 
    RouterModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [LoginComponent],
    exports: [LoginComponent]
})

export class LoginModule { }



// WEBPACK FOOTER //
// ./src/app/login/login.module.ts